import React from 'react';
import '../general/SmartCard.css';
import PropTypes from 'prop-types';
import { buildMemberHierarchy, flattenMemberTreeForDisplay } from '../../utils/Utilities';

function FamilySmartCard({ familyData, printEnable }) {
  const family = familyData?.family;
  const familyMembers = family?.familyMembers || [];

  if (familyMembers.length === 0) return null;

  const currentDate = new Date().toLocaleDateString('en-GB'); // dd/mm/yyyy

  // Sort family members by name for display
  const memberTree = buildMemberHierarchy(family);
  const sortedFamilyMembers = flattenMemberTreeForDisplay(memberTree);

  // Effective family head aadhar for marking the head
  const effectiveHeadAadhar = family.familyHeadAadhar;

  return (
    <>
      {printEnable === true && (
        <div className="no-print" style={{ marginBottom: '10px' }}>
          <button onClick={() => window.print()}>🖨️ Print Smart Card</button>
        </div>
      )}


      <div className="smart-card-container">
        {/* Front of the Smart Card */}
        <div className="smart-card">
          {/* Watermark behind content */}


          <div className="photo-heading">
            <img
              src="/logo192.png"
              alt="👤"
              className="photo"
            />

            <div className="heading">
              <strong>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள்</strong>
              <br />
              அத்திபாளையம் கிராமம், கரூர் மாவட்டம்
            </div>
          </div>

          <div className="smart-card-front">
            <div className="watermark">
              <img src="/logo192.png" alt="Logo watermark" />
            </div>
            <div className="smart-card-item">
              <div className="left-side">
                <strong>குடும்ப எண்:</strong>
                <span>{family.id || ""}</span>
                <br />
                {family.kootamName && family.kootamName !== "பிற" && (
                  <>
                    <strong>கூட்டம்:</strong> <span>{family.kootamName}</span>
                  </>

                )}
                {family.kootamName && family.kootamName.trim() === "பிற" && (
                  <>
                    <strong>பிற:</strong><span> {family.customGroup}</span>
                  </>

                )}
                <br />
                <br />
                <strong>முகவரி:</strong>
                <span>
                  {family?.permanentAddressLine1_tamil && family.permanentAddressLine1_tamil + ', '}
                  {family?.permanentAddressLine2_tamil && family.permanentAddressLine2_tamil + ', '}
                  {family?.permanentAddressLine3_tamil && family.permanentAddressLine3_tamil + ', '}
                  {family?.addressData?.permanentAddress?.subAreas?.[0]?.name_tamil?.split("|").reverse().map((token) => token + ", ")}
                  {family?.addressData?.permanentAddress?.name_tamil && family.addressData.permanentAddress.name_tamil + ', '}
                  {family?.addressData?.permanentAddress?.block_tamil && family.addressData.permanentAddress.block_tamil + ', '}
                  {family?.addressData?.permanentAddress?.district_tamil && family.addressData.permanentAddress.district_tamil + ', '}
                  {family?.addressData?.permanentAddress?.state_tamil && family.addressData.permanentAddress.state_tamil + ', '}
                  {family?.addressData?.permanentAddress?.pincode && family.addressData.permanentAddress.pincode}
                </span>
              </div>

              <div className="right-side">
                {/* Family Head Photo moved to right side */}
                <img
                  src={family?.familyHeadPhotoPath?.signedUrl}
                  alt="👤"
                  className="photo photo-right"
                />
              </div>
            </div>


          </div>
        </div>

        {/* Back of the Smart Card */}
        <div className="smart-card">
          <div className="smart-card-back">
            <div className="watermark">
              <img src="/logo192.png" alt="Logo watermark" />
            </div>
            <div className="left-side">
              <div className="family-members-list">
                <strong>குடும்ப உறுப்பினர்கள்:</strong>
                <br />
                {sortedFamilyMembers.map((member) => {
                  const isFamilyHead = member.aadhar === effectiveHeadAadhar;
                  return (
                    <div key={member.aadhar}>
                      {member.firstName || ""} {member.lastName || ""}
                      {isFamilyHead && " (தலைவர்)"}
                    </div>
                  );
                })}
              </div>
            </div>

            {family?.addressData?.tempAddress && (
              <div className="right-side">
                <div className="temp-address-rotated">
                  <strong>தற்காலிக முகவரி:</strong>
                  <br />
                  <span>
                    {family?.tempAddressLine1_tamil && family.tempAddressLine1_tamil + ', '}
                    {family?.tempAddressLine2_tamil && family.tempAddressLine2_tamil + ', '}
                    {family?.tempAddressLine3_tamil && family.tempAddressLine3_tamil + ', '}
                    {family?.addressData?.tempAddress?.subAreas?.[0]?.name_tamil?.split("|").reverse().map((token) => token + ", ")}
                    {family?.addressData?.tempAddress?.name_tamil && family.addressData.tempAddress.name_tamil + ', '}
                    {family?.addressData?.tempAddress?.block_tamil && family.addressData.tempAddress.block_tamil + ', '}
                    {family?.addressData?.tempAddress?.district_tamil && family.addressData.tempAddress.district_tamil + ', '}
                    {family?.addressData?.tempAddress?.state_tamil && family.addressData.tempAddress.state_tamil + ', '}
                    {family?.addressData?.tempAddress?.pincode && family.addressData.tempAddress.pincode}
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="printed-date">
            {currentDate}
          </div>
        </div>
      </div>
    </>
  );
}

FamilySmartCard.propTypes = {
  userRole: PropTypes.string.isRequired,
  familyData: PropTypes.shape({
    family: PropTypes.shape({
      id: PropTypes.string,
      familyHeadAadhar: PropTypes.string.isRequired,
      kootamName: PropTypes.string,
      customGroup: PropTypes.string,
      familyMembers: PropTypes.arrayOf(
        PropTypes.shape({
          aadhar: PropTypes.string.isRequired,
          firstName: PropTypes.string,
          lastName: PropTypes.string,
          dob: PropTypes.string,
          relationship: PropTypes.string,
          parentId: PropTypes.string,
          maskedAadhar: PropTypes.string,
          status: PropTypes.string,
          mobile: PropTypes.string,
          mobile2: PropTypes.string,
          email: PropTypes.string,
        })
      ),
      familyHeadPhotoPath: PropTypes.shape({
        signedUrl: PropTypes.string,
      }),
      permanentAddressLine1_tamil: PropTypes.string,
      permanentAddressLine2_tamil: PropTypes.string,
      permanentAddressLine3_tamil: PropTypes.string,
      tempAddressLine1_tamil: PropTypes.string,
      tempAddressLine2_tamil: PropTypes.string,
      tempAddressLine3_tamil: PropTypes.string,
      addressData: PropTypes.shape({
        permanentAddress: PropTypes.object,
        tempAddress: PropTypes.object,
      }),
    }).isRequired,
  }).isRequired,
};

export default FamilySmartCard;
